<template>
  <div class="mt-3">
    <div class="mb-3">
      SPI: <strong>{{ controlePage.spi }}</strong>
    </div>
    <fccModal
      :idModal="'modal-edit-pagamento'"
      titleModal="Adicionar Pagamento"
      size="lg"
      centered
      escondeFooter
      travaEsc
      travaBack
      @close=";(pedido = null), (numeroDoPedido = '')"
    >
      <div class="d-flex w-50 justify-content-between mb-3">
        <fcc-input class="mt-4 mr-3 flex-grow-1" v-model="numeroDoPedido"
          >Digite o número do pedido:</fcc-input
        >
        <div class="align-self-end" v-if="pedido == null">
          <fcc-button @click="buscar" :disabled="!numeroDoPedido">Buscar</fcc-button>
        </div>
      </div>
      <b-form @submit.prevent="transferirPedido" autocomplete="off">
        <template v-if="pedido != null">
          <div class="row mt-4">
            <div class="col-sm-4">
              <fcc-date-input
                class="form-control"
                type="date"
                v-model="emissaoPagamento.dataPagamento"
                required
                >Data Pagamento</fcc-date-input
              >
            </div>
            <div class="col-sm-3 pt-2">
              <span><toggle-button v-model="emissaoPagamento.isencao" :sync="true" /> Isenção</span>
            </div>
            <div class="col-sm-3 pt-2">
              <span
                ><toggle-button
                  v-model="emissaoPagamento.reducao"
                  :sync="true"
                  :disabled="!emissaoPagamento.isencao"
                />
                Redução</span
              >
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-12 text-right">
              <fcc-button tipo="submit"
                ><font-awesome-icon icon="save" size="lg" /> Inserir Pagamento / Isenção</fcc-button
              >
            </div>
          </div>
        </template>
      </b-form>
    </fccModal>
    <div class="w-100">
      <fcc-table
        :fields="fieldsLogs"
        striped
        hover
        responsive
        :por-page="'100'"
        search
        addFilter
        pagination
        field-visibility
        pdf
        xls
        csv
        title-page="Logs Gerar Boleto"
        title-p-d-f="Logs Gerar Boleto"
        :items="itemsLogs"
      ></fcc-table>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import fccStore from '@/store'

export default {
  data() {
    return {
      numeroDoPedido: '',
      pedido: null,
      emissaoPagamento: null,
      testeBoleto: null,
      logs: [],
      fieldsLogs: [
        { key: 'numeroPedido', label: 'Número do Pedido', sortable: true, active: true },
        {
          key: 'nrstatus',
          label: 'NRStatus',
          sortable: true,
          active: true
        },
        {
          key: 'isencao',
          label: 'Isenção',
          sortable: true,
          active: true,
          formatter(data) {
            return data ? 'Sim' : 'Não'
          }
        },
        {
          key: 'reducao',
          label: 'Redução',
          sortable: true,
          active: true,
          formatter(data) {
            return data ? 'Sim' : 'Não'
          }
        },
        {
          key: 'dtPagto',
          label: 'Data de Pagamento',
          sortable: true,
          active: true,
          formatter(data) {
            const [datax] = data.split('T')
            const [dia, mes, ano] = datax.split('-')
            return `${ano}/${mes}/${dia}`
          }
        },
        {
          key: 'dtInsert',
          label: 'Data Inserção',
          sortable: true,
          active: true,
          formatter(data) {
            const [datax] = data.split('T')
            const [dia, mes, ano] = datax.split('-')
            return `${ano}/${mes}/${dia}`
          }
        },
        { key: 'nomeFuncionario', label: 'Nome do Funcionário', sortable: true, active: true }
      ],
      itemsLogs: []
    }
  },
  props: {
    controlePage: Object
  },
  methods: {
    transferirPedido() {
      this.callConfirm(
        !this.emissaoPagamento.isencao
          ? 'Deseja realmente inserir o pagamento do candidato?'
          : 'Deseja realmente inserir a isenção do candidato?',
        ''
      ).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          axios
            .post(fccStore.state.baseUrlNodeApi + 'inserir-pagamento', this.emissaoPagamento, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(() => {
              this.listarPedido()
              this.$root.$emit('bv::hide::modal', 'modal-edit-pagamento')
              this.callToast('Pagamento inserido com sucesso')
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto)
        }
      })
    },
    addField() {
      this.emissaoPagamento = {
        numeroPedido: '',
        dataPagamento: '',
        idPublicacao: this.controlePage.idpublicacao,
        isencao: false,
        reducao: false,
        nrstatus: 0,
        cdfuncionario: this.dadosUserSession.usuCdFuncionario
      }
      this.$root.$emit('bv::show::modal', 'modal-edit-pagamento')
    },
    formatarData(dataStr) {
      const [data] = dataStr.split(' ')
      const [dia, mes, ano] = data.split('/')

      return `${dia}/${mes}/${ano}`
    },
    isEmpty(obj) {
      return obj && Object.keys(obj).length === 0
    },
    listarPedido() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          fccStore.state.baseUrlNodeApi +
            'controle-insercao-pagamento/' +
            this.controlePage.idpublicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.itemsLogs = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    buscar() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          fccStore.state.baseUrlBoleto + 'Boleto/ArquivoCobranca/' + this.numeroDoPedido,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.pedido = response?.data || null
          if (this.pedido != null) {
            this.emissaoPagamento.numeroPedido = parseInt(this.numeroDoPedido)
          }
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },
  mounted() {
    this.listarPedido()
  }
}
</script>